const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNDE0IDExbDQuNDE0IDQuNzA3TDE3LjQxNCAyMWwtMi0xTDE4IDE2LjcwN0g1LjQxNHYtMkgxOEwxNS40MTQgMTJsMi0xem0tMTAtOGwyIDEtMi41ODYgMi43MDdoMTIuNTg2djJINi44MjhMOS40MTQgMTJsLTIgMUwzIDcuNzA3IDcuNDE0IDN6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  M as default
};
//# sourceMappingURL=transfer-ed80a660.mjs.map
